__turbopack_context__.v({
  "activeSection": "About-module-scss-module__647jFG__activeSection",
  "calendarTable": "About-module-scss-module__647jFG__calendarTable",
  "cookiePolicyTable": "About-module-scss-module__647jFG__cookiePolicyTable",
  "htmlContainer": "About-module-scss-module__647jFG__htmlContainer",
  "lastUpdateText": "About-module-scss-module__647jFG__lastUpdateText",
});
